var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSignOutWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 10.3333V7.74999C18.0833 7.06484 17.8112 6.40776 17.3267 5.92329C16.8422 5.43882 16.1851 5.16665 15.5 5.16665H6.45833C5.77319 5.16665 5.11611 5.43882 4.63164 5.92329C4.14717 6.40776 3.875 7.06484 3.875 7.74999V23.25C3.875 23.9351 4.14717 24.5922 4.63164 25.0767C5.11611 25.5611 5.77319 25.8333 6.45833 25.8333H15.5C16.1851 25.8333 16.8422 25.5611 17.3267 25.0767C17.8112 24.5922 18.0833 23.9351 18.0833 23.25V20.6667",
    stroke: "white",
    strokeWidth: 1.40909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04165 15.5H27.125M27.125 15.5L23.25 11.625M27.125 15.5L23.25 19.375",
    stroke: "white",
    strokeWidth: 1.40909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOutWhite);
export default __webpack_public_path__ + "static/media/Icon_SignOut_White.c85b697dd446826b03477a00edc08914.svg";
export { ForwardRef as ReactComponent };